document.addEventListener("DOMContentLoaded", () => {
  // Position switchers

  const setWidthPositionSwitchers = () => {
    const positionSwitchers = document.querySelectorAll(".tuning-buttons__position");

    positionSwitchers.forEach((positionSwitcher) => {
      const spanElems = positionSwitcher.querySelectorAll("span");
      const tuningButtonsPoint = positionSwitcher.querySelector(".tuning-buttons__point");
      let maxWidth = 0;
      spanElems.forEach((el) => {
        if (el.offsetWidth > maxWidth) maxWidth = el.offsetWidth;
      });

      maxWidth += Number(tuningButtonsPoint.offsetWidth) + 30;
      positionSwitcher.style.width = maxWidth + "px";
    });
  };
  setWidthPositionSwitchers();

  // Material switchers
  const setWidthMaterialSwitchers = () => {
    const materialSwitchers = document.querySelectorAll(".tuning-buttons__material");

    materialSwitchers.forEach((materialSwitcher) => {
      const textElems = materialSwitcher.querySelectorAll(".tuning-buttons__text");
      let maxWidth = 0;
      textElems.forEach((el) => {
        if (el.offsetWidth > maxWidth) maxWidth = el.offsetWidth;
      });
      materialSwitcher.style.width = maxWidth * 2 + 40 + "px";
      textElems.forEach((el) => (el.style.width = "50%"));
    });
  };
  setWidthMaterialSwitchers();
});
